import { render, staticRenderFns } from "./QualityCommentHistory.vue?vue&type=template&id=fd2da386"
import script from "./QualityCommentHistory.vue?vue&type=script&lang=js"
export * from "./QualityCommentHistory.vue?vue&type=script&lang=js"
import style0 from "./QualityCommentHistory.vue?vue&type=style&index=0&id=fd2da386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports